"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let MessageBox = (() => {
    var _MessageBox_messageList_accessor_storage, _MessageBox_messageForm_accessor_storage, _MessageBox_messageInput_accessor_storage;
    let _classDecorators = [(0, decorators_js_1.customElement)("message-box")];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = lit_1.LitElement;
    let _instanceExtraInitializers = [];
    let _messageList_decorators;
    let _messageList_initializers = [];
    let _messageForm_decorators;
    let _messageForm_initializers = [];
    let _messageInput_decorators;
    let _messageInput_initializers = [];
    var MessageBox = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _MessageBox_messageList_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _messageList_initializers, void 0)));
            _MessageBox_messageForm_accessor_storage.set(this, __runInitializers(this, _messageForm_initializers, void 0));
            _MessageBox_messageInput_accessor_storage.set(this, __runInitializers(this, _messageInput_initializers, void 0));
        }
        get messageList() { return __classPrivateFieldGet(this, _MessageBox_messageList_accessor_storage, "f"); }
        set messageList(value) { __classPrivateFieldSet(this, _MessageBox_messageList_accessor_storage, value, "f"); }
        get messageForm() { return __classPrivateFieldGet(this, _MessageBox_messageForm_accessor_storage, "f"); }
        set messageForm(value) { __classPrivateFieldSet(this, _MessageBox_messageForm_accessor_storage, value, "f"); }
        get messageInput() { return __classPrivateFieldGet(this, _MessageBox_messageInput_accessor_storage, "f"); }
        set messageInput(value) { __classPrivateFieldSet(this, _MessageBox_messageInput_accessor_storage, value, "f"); }
        addMessage(message) {
            const item = document.createElement("chat-message");
            item.innerHTML = message.body + "<br/>";
            item.setAttribute("msgType", message.author === "system" ? "msg-receive" : "msg-send");
            this.appendChild(item);
            // Scroll to bottom
            this.scrollToBottom();
        }
        scrollToBottom() {
            this.messageList.scrollTop = this.messageList.scrollHeight;
        }
        onMessage(e) {
            // Dispatch on-message
            this.dispatchEvent(new CustomEvent("on-message", {
                bubbles: true,
                composed: true,
                detail: {
                    body: e.detail.message.toString(),
                    author: "",
                },
            }));
            // Clear input
            this.messageInput.value = "";
        }
        render() {
            return (0, lit_1.html) `
      <div class="message-list" id="message-list">
        <slot></slot>
      </div>
      <br />
      <form-event @on-submit=${this.onMessage}>
        <form action="submit" slot="form">
          <sl-input name="message" size="large" id="message-input">
            <sl-icon-button
              type="submit"
              name="chat"
              slot="suffix"
            ></sl-icon-button>
          </sl-input>
        </form>
      </form-event>
    `;
        }
    };
    _MessageBox_messageList_accessor_storage = new WeakMap();
    _MessageBox_messageForm_accessor_storage = new WeakMap();
    _MessageBox_messageInput_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "MessageBox");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _messageList_decorators = [(0, decorators_js_1.query)("#message-list")];
        _messageForm_decorators = [(0, decorators_js_1.query)("#message-form")];
        _messageInput_decorators = [(0, decorators_js_1.query)("#message-input")];
        __esDecorate(_classThis, null, _messageList_decorators, { kind: "accessor", name: "messageList", static: false, private: false, access: { has: obj => "messageList" in obj, get: obj => obj.messageList, set: (obj, value) => { obj.messageList = value; } }, metadata: _metadata }, _messageList_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _messageForm_decorators, { kind: "accessor", name: "messageForm", static: false, private: false, access: { has: obj => "messageForm" in obj, get: obj => obj.messageForm, set: (obj, value) => { obj.messageForm = value; } }, metadata: _metadata }, _messageForm_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _messageInput_decorators, { kind: "accessor", name: "messageInput", static: false, private: false, access: { has: obj => "messageInput" in obj, get: obj => obj.messageInput, set: (obj, value) => { obj.messageInput = value; } }, metadata: _metadata }, _messageInput_initializers, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        MessageBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = (0, lit_1.css) `
    .message-list {
      overflow-y: auto;
      height: 150px;
      border: 1px solid #ccc; /* Add styling as needed */
    }
  `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return MessageBox = _classThis;
})();
exports.MessageBox = MessageBox;
